import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";

import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Programme from "./pages/Programme";
import Inscription from "./pages/Inscription";
import Classement from "./pages/Classement";
import Galerie from "./pages/Galerie";
import Contact from "./pages/Contact";
import Autorisation from "./pages/Autorisation";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import LiveScore from "./pages/LiveScore";
import Tableau from "./pages/Tableau";

function Shell() {
  const { pathname } = useLocation();
  const bare = pathname === "/live" || pathname === "/tableau";
  return (
    <>
      {!bare && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programme" element={<Programme />} />
          <Route path="/inscription" element={<Inscription />} />
          <Route path="/classement" element={<Classement />} />
          <Route path="/galerie" element={<Galerie />} />
          <Route path="/autorisation" element={<Autorisation />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/live" element={<LiveScore />} />
          <Route path="/tableau" element={<Tableau />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!bare && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#0A0A0A] text-white min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#171717",
                color: "#fff",
                border: "1px solid #333",
                borderRadius: "2px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
